function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.6264 5.46341V42.5366H57.1955V5.46341H30.6264Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1955 43H30.6264C30.37 43 30.163 42.793 30.163 42.5366V5.46341C30.163 5.20699 30.37 5 30.6264 5H57.1955C57.4519 5 57.6589 5.20699 57.6589 5.46341V42.5366C57.6589 42.793 57.4519 43 57.1955 43ZM31.0898 42.0732H56.7321V5.92683H31.0898V42.0732Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1061 8.55285H47.3618V39.4472H54.1061V8.55285Z",
    fill: "#C4BFB6",
    style: {
      fill: "#C4BFB6",
      fill: "color(display-p3 0.7686 0.7490 0.7137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1061 39.9106H47.3618C47.1054 39.9106 46.8984 39.7036 46.8984 39.4472V8.55285C46.8984 8.29642 47.1054 8.08943 47.3618 8.08943H54.1061C54.3625 8.08943 54.5695 8.29642 54.5695 8.55285V39.4472C54.5695 39.7036 54.3625 39.9106 54.1061 39.9106ZM47.8252 38.9837H53.6426V9.01626H47.8252V38.9837Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6423 43H26.8944C26.6379 43 26.4309 42.793 26.4309 42.5366C26.4309 42.2802 26.6379 42.0732 26.8944 42.0732H59.6423C59.8987 42.0732 60.1057 42.2802 60.1057 42.5366C60.1057 42.793 59.8987 43 59.6423 43Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8947 38.3659H33.7158C33.4594 38.3659 33.2524 38.1589 33.2524 37.9024C33.2524 37.646 33.4594 37.439 33.7158 37.439H39.8947C40.1511 37.439 40.3581 37.646 40.3581 37.9024C40.3581 38.1589 40.1511 38.3659 39.8947 38.3659Z",
    fill: "#C4BFB6",
    style: {
      fill: "#C4BFB6",
      fill: "color(display-p3 0.7686 0.7490 0.7137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1467 5.46341L33.7158 8.55285V39.4472L45.1467 42.5366H47.3618V5.46341H45.1467ZM44.2724 40.238L35.5695 37.7449V10.1872L44.2724 7.76195V40.238Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3618 43H45.1467C45.1065 43 45.0664 42.9938 45.0262 42.9846L33.5953 39.8951C33.3945 39.8395 33.2524 39.6572 33.2524 39.4472V8.55285C33.2524 8.34276 33.3914 8.16049 33.5953 8.10488L45.0262 5.01545C45.0664 5.00618 45.1065 5 45.1467 5H47.3618C47.6183 5 47.8252 5.20699 47.8252 5.46341V42.5366C47.8252 42.793 47.6183 43 47.3618 43ZM45.2085 42.0732H46.8984V5.92683H45.2085L34.1792 8.90813V39.0919L45.2085 42.0732ZM44.2724 40.7015C44.2292 40.7015 44.1859 40.6953 44.1457 40.6829L35.4428 38.1898C35.2451 38.1341 35.1061 37.9519 35.1061 37.7449V10.1872C35.1061 9.98016 35.2451 9.79789 35.4459 9.74228L44.1488 7.31707C44.2878 7.27691 44.4392 7.3078 44.5535 7.39431C44.6678 7.48081 44.7358 7.61984 44.7358 7.76195V40.235C44.7358 40.3802 44.6678 40.5161 44.5505 40.6057C44.4701 40.6675 44.3713 40.6984 44.2724 40.6984V40.7015ZM36.0329 37.3927L43.809 39.6202V8.37366L36.0329 10.5393V37.3927Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasement);
export default __webpack_public_path__ + "static/media/Casement.b4632c2709fd1445e768b96ac6c57dd0.svg";
export { ForwardRef as ReactComponent };